export default ()=>{
    const prDetail = document.querySelector('.product-detail');

    if (prDetail){
        const quantity = document.querySelectorAll('[data-quantity-wrapper]');

        quantity.forEach(wrapper =>{
            const inc = wrapper.querySelector('.increase');
            const dec = wrapper.querySelector('.decrease');
            const input = wrapper.querySelector('[name="quantity"]');
            dec.addEventListener('click', ()=>{
                if (parseInt(input.value) > 1){
                    input.value--
                }
            })
            inc.addEventListener('click', ()=>{
                input.value++
            })
        })
        const button = document.querySelector('[data-open-select]');
        const wrapper = document.querySelector('[data-show-sizes]');
        const buttonColor = document.querySelector('[data-open-color]');
        const wrapperColor = document.querySelector('[data-color-wrapper]');
        if (window.innerWidth < 640 ){
            if (button) {
                button.addEventListener('click', ()=>{
                    button.classList.toggle('is-active');
                    wrapper.classList.toggle('is-active');
                    if (buttonColor.classList.contains('is-active') || wrapperColor.classList.contains('is-active')){
                        buttonColor.classList.remove('is-active');
                        wrapperColor.classList.remove('is-active')
                    }
                })
            }
            if (buttonColor) {
                buttonColor.addEventListener('click', ()=>{
                    buttonColor.classList.toggle('is-active');
                    wrapperColor.classList.toggle('is-active');
                    if (button.classList.contains('is-active') || wrapper.classList.contains('is-active')){
                        button.classList.remove('is-active');
                        wrapper.classList.remove('is-active')
                    }
                })
            }
           
            
            document.addEventListener('click', (e)=>{
                const target = e.target;

                if (wrapper || wrapperColor) {
                    if(wrapperColor.classList.contains('is-active') || wrapper.classList.contains('is-active')){

                        if ((target !== buttonColor && target.closest('.product-actions_colors') !==  wrapperColor && target.closest('.product-actions__mobile') !==  buttonColor)) {
                            buttonColor.classList.remove('is-active');
                            wrapperColor.classList.remove('is-active');
                           
                        }
                        if  (target !== button && target.closest('.product-actions_sizes') !==  wrapper && target.closest('.product-actions__mobile') !==  button) {
                            button.classList.remove('is-active');
                            wrapper.classList.remove('is-active');
                        }
                    }
                }
                
            })
        }
        
    }
}